import React from 'react';
import {Image, Platform, StyleSheet, View} from 'react-native';

import {OrderLineSticker} from '../transport/apiServiceResponse';

import {Badge} from './article/priceBadges';
import ErrorBoundary from './ErrorBoundary';

type Item = {
  deal: boolean;
  saving: boolean;
  position: {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'right';
  };
  labels: string[];
  links?: {
    image: string;
  };
};

type ChevronMotifProps = {
  item: Item;
  isProductScreen?: boolean;

  /**
   * small is used on cart screen cart item and last minute
   * only used for sns and bottlemart
   */
  small?: boolean;
};

export const getStickerTextParts = (item: OrderLineSticker) => {
  const {labels} = item;
  const text = (labels?.[0] || '').toLocaleUpperCase(); // "Save", "2 for"...
  const price = labels?.length > 1 ? labels?.[1] : '';
  return {text, price};
};

const ChevronMotif = ({item, small, isProductScreen = false}: ChevronMotifProps) => {
  // Optimized for 8pt grid system & minimum legibility threshold
  const baseSize = 56;

  const {position, links} = item;
  const {vertical, horizontal} = position;

  const {text, price} = getStickerTextParts(item as OrderLineSticker);

  const dynStyles = StyleSheet.create({
    svgContainer: {
      width:
        isProductScreen || small
          ? undefined
          : Platform.OS === 'web'
            ? `${baseSize - 5}%`
            : `${baseSize}%`,
      marginRight: isProductScreen ? 15 : undefined,
      padding: 2,
      position: 'absolute',
      [horizontal]: 2,
      [vertical]: 2,
      alignItems: horizontal === 'left' ? 'flex-start' : 'flex-end',
      justifyContent: vertical === 'top' ? 'flex-start' : 'flex-end',
    },
    stickerImage: {
      position: 'absolute',
      aspectRatio: 1,
      width: '35%',
      [horizontal]: 0,
      [vertical]: 2,
    },
  });

  const sizeProps = small ? {size: baseSize} : {};

  if (typeof links?.image === 'string') {
    const url = links?.image.replace('files', 'images');
    return <Image source={{uri: url}} style={dynStyles.stickerImage} resizeMode="contain" />;
  } else {
    return (
      <ErrorBoundary message="ChevronMotif-svg">
        <View style={dynStyles.svgContainer} testID="chevron-motif-svg-container">
          <Badge price={price} text={text} {...sizeProps} />
        </View>
      </ErrorBoundary>
    );
  }
};

export default ChevronMotif;
